import { render } from "./RequestReceived.vue?vue&type=template&id=5c6fbd42&scoped=true"
import script from "./RequestReceived.vue?vue&type=script&lang=js"
export * from "./RequestReceived.vue?vue&type=script&lang=js"

import "./RequestReceived.vue?vue&type=style&index=0&id=5c6fbd42&scoped=true&lang=css"

import exportComponent from "D:\\vue\\Vue_Lessons\\coachApps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6fbd42"]])

export default __exports__